import React from 'react';
import { Card } from './PublicShell';
const tel=phone=>{const d=String(phone||'').replace(/\D/g,'');return d?`tel:+${d.length===10?'1'+d:d}`:'';};
export default function ContactsCard({contacts}){
  if(!contacts?.length)return null;
  return <Card title="Program Contacts" subtitle="Contacts from the existing Line Medic sheet"><div className="pub-contact-grid">
    {contacts.map(c=><div className="pub-contact" key={c.role}><span className="pub-field">{c.role}</span><div className="pub-name">{c.name||'—'}</div>{c.phone?<a href={tel(c.phone)}>{c.phone}</a>:'—'}</div>)}
  </div></Card>;
}
